import React from 'react';
import WazuhLogo from './img/wazuh-log.svg';

// "wazuh." comes from the brand SVG, "Partners" is set in Manrope next to it so
// the lockup keeps its spacing and weight at any size.
const WazuhPartnersLogo = ({
  className = '',
  logoClassName = 'h-[19px]',
  textClassName = 'text-[21px]',
}) => (
  <div className={`flex items-center ${className}`}>
    <img alt='Wazuh' className={logoClassName} src={WazuhLogo} />
    <span
      className={`ml-[10px] font-manrope font-normal leading-none text-mainblack ${textClassName}`}
    >
      Partners
    </span>
  </div>
);

export default WazuhPartnersLogo;
